<template>
  <div>
    <card-wrapper
      id="leads-list"
      :show-divider="true"
      :title="$t('leads.list.title')"
      :action-button-data="{title: $t('title.create-lead'), icon: 'fak fa-light fa-m-file-plus'}"
      @on-open-action-button-dialog="handleLeadDialogOpenClose">
      <leads-table
        :lead-list="leadList"
        :loading="isLoadingLeads"
        @mark-lead-as-read="markLeadAsRead"
        @mark-lead-as-lost="maskLeadAsLost"
        @refresh-leads="refetchLeads" />
      <create-lead-dialog
        :is-dialog-open="isLeadDialogOpen"
        @onClose="handleLeadDialogOpenClose"
        :is-contact-search-bar-select-mode="false"
        @onCreated="refetchLeads" />
    </card-wrapper>
  </div>
</template>

<script lang="ts">
import {defineComponent, onUnmounted, ref, watch} from '@vue/composition-api'

import CardWrapper from '@/components/general/CardWrapper.vue'
import LeadsTable from '@/components/leads/LeadsTable.vue'
import CreateLeadDialog from '@/components/offer-manager/CreateLeadDialog.vue'
import {useLeadsList} from '@/composables'
import {eventBus} from '@/main'

export default defineComponent({
  name: 'Leads',
  components: {LeadsTable, CardWrapper, CreateLeadDialog},
  setup() {
    const {data: leadList, isLoading, markLeadAsRead, maskLeadAsLost, refetch} = useLeadsList()
    const isLeadDialogOpen = ref(false)
    const isLoadingLeads = ref(isLoading.value)

    const refetchLeads = async () => {
      isLoadingLeads.value = true
      await new Promise(resolve => setTimeout(resolve, 3000))
      refetch()
    }

    watch(isLoading, newValue => {
      isLoadingLeads.value = newValue
    })

    const handleLeadDialogOpenClose = () => {
      isLeadDialogOpen.value = !isLeadDialogOpen.value
    }

    eventBus.$on('on-created-lead', refetchLeads)

    onUnmounted(() => {
      eventBus.$off('on-created-lead', refetchLeads)
    })

    return {
      isLeadDialogOpen,
      handleLeadDialogOpenClose,
      leadList,
      isLoadingLeads,
      markLeadAsRead,
      maskLeadAsLost,
      refetchLeads,
    }
  },
})
</script>

<style lang="scss">
#leads-list,
#leads-create {
  &.leads-wrapper {
    background-color: var(--v-background-base) !important;
  }

  .leads-card-wrapper {
    width: 100%;
  }

  .my-spacer {
    -webkit-box-flex: 1 !important;
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }

  .link {
    text-align: center;
    text-decoration: underline;
    font: normal normal normal 16px/26px 'ProximaNovaRegular';
    letter-spacing: 0px;
    color: #3797f0;
    opacity: 1;

    &:hover {
      cursor: pointer;
    }
  }

  .search-input {
    fieldset {
      border-radius: 0;
      border: 1px solid #bdbdbd;
      height: 55px;
    }

    .v-text-field__slot {
      height: 50px;
    }

    width: 100%;
    max-width: 400px;

    ::placeholder {
      text-align: left;
      font: normal normal normal 16px/22px 'ProximaNovaRegular';
      letter-spacing: 0px;
      color: var(--v-gray-lighten3);
      opacity: 1;
    }

    .v-input__icon--clear button {
      font-family: 'mapitfont-v1' !important;
      text-transform: none;
      height: 50px;
      margin-top: 8px;
      color: var(--v-gray-lighten3) !important;
    }
  }

  .search-btn {
    height: 50px !important;
    font-family: 'mapitfont-v1' !important;
  }

  .text-blue {
    color: #0075eb !important;
  }
}

.title {
  flex: 1;
  text-align: center;
  color: var(--v-primary-base);
  font-size: 28px !important;
  text-transform: uppercase;
  font-family: 'ProximaNovaExCnSbold', sans-serif;
  letter-spacing: -0.01em;
  line-height: 1.8;
}
</style>
